import { tns } from '../../../../../node_modules/tiny-slider/src/tiny-slider.js';

function newsSlider () {
  const slider = document.querySelector('[data-news-slider'),
        options = {
          container: '[data-news-slider]',
          mode: 'carousel',
          items: 1,
          loop: false,
          controls: true,
          controlsPosition: 'bottom',
          nav: false,
          responsive: {
            576: {
              items: 2
            },
            992: {
              items: 3
            }
          },
          speed: 400
        };

  if (slider) {
    const sliderNews = tns(options);
    return sliderNews;
  }
}

newsSlider();
